import React, { Component } from 'react';
import '../styles.css';
import { RED, YELLOW, GREEN, BLUE, MAGENTA } from '../../HOME/const';
import { TRANSITION_DURATION } from '../const';

class Cell extends Component {
  constructor(props) {
    super(props);

    if (!props) {
      return;
    }

    const { row, col } = props.cell;
    this.row = row;
    this.col = col;

    this.area = `${row}/${col}`;
    this.translate = `translate(${1 - col}px, ${1 - row}px)`;
  }

  handleTouch = () => {
    this.touch = true;
    this.handleClick();
  };

  handleMouseDown = () => {
    if (!this.touch) {
      this.handleClick();
    }
  };

  handleClick = () => {
    const { board } = this.props;

    if (board && !board.blocked()) {
      board.onClick(this);
    }
  };

  getColor = color => {
    switch (color) {
      case 'red':
        return RED;
      case 'yellow':
        return YELLOW;
      case 'green':
        return GREEN;
      case 'blue':
        return BLUE;
      case 'magenta':
        return MAGENTA;
      default:
        return 'transparent';
    }
  };

  isColor = color => {
    const { cell } = this.props;
    return cell.color === color || (cell.color === 'transparent' && cell.prevColor === color);
  };

  renderCell = color => {
    const { cell, shapes } = this.props;
    const shape = shapes[color];
    const background = this.getColor(cell.color);
    const dur = background === 'transparent' ? TRANSITION_DURATION : 0;
    const transition = dur ? `background ${dur}ms linear, border-color ${dur}ms linear` : 'initial';
    const style = { gridArea: '1/1', background, transition };
    let polygon;

    switch (shape) {
      case 'square':
        polygon =
          'polygon(0% 0%, 0% 100%, 30% 100%, 30% 30%, 70% 30%, 70% 70%, 30% 70%, 30% 60%, 60% 60%, 60% 40%, 40% 40%, 40% 60%, 30% 60%, 30% 100%, 100% 100%, 100% 0%)';
        break;
      case 'vert':
        polygon = 'polygon(0% 0%, 0% 100%, 45% 100%, 45% 30%, 55% 30%, 55% 70%, 45% 70%, 45% 100%, 100% 100%, 100% 0%)';
        break;
      case 'horz':
        polygon = 'polygon(0% 0%, 0% 100%, 30% 100%, 30% 45%, 70% 45%, 70% 55%, 30% 55%, 30% 100%, 100% 100%, 100% 0%)';
        break;
      case 'plus':
        polygon =
          'polygon(0% 0%, 0% 100%, 30% 100%, 30% 45%, 45% 45%, 45% 30%, 55% 30%, 55% 45%, 70% 45%, 70% 55%, 55% 55%, 55% 70%, 45% 70%, 45% 55%, 30% 55%, 30% 100%, 100% 100%, 100% 0%)';
        break;
      default:
    }

    switch (shape) {
      case 'square':
      case 'vert':
      case 'horz':
      case 'plus':
        return <div style={{ ...style, WebkitClipPath: polygon, clipPath: polygon }} />;
      case 'circle':
        return (
          <>
            <div
              style={{
                ...style,
                width: '20%',
                height: '20%',
                borderRadius: '50%',
                alignSelf: 'center',
                justifySelf: 'center',
              }}
            />
            <div
              style={{
                ...style,
                borderColor: style.background,
                background: 'transparent',
                width: '40%',
                height: '40%',
                borderRadius: '50%',
                borderStyle: 'solid',
                borderWidth: '0.5em',
                justifySelf: 'center',
                alignSelf: 'center',
              }}
            />
          </>
        );
      default:
    }
  };

  render() {
    const { width, cell, board } = this.props;
    const off = width / 2 + 0.5;
    const transform = `translate(-${off}px, -${off}px)`;
    const fontSize = `${width}px`;

    return (
      <div
        className="tm-cell"
        ref={el => {
          if (el) {
            this.rect = el.getBoundingClientRect();
          }
        }}
        style={{ width, height: width, gridArea: this.area, transform: this.translate, fontSize }}>
        <div style={{ width, height: width, overflow: 'hidden', gridArea: '1/1', display: 'grid' }}>
          {this.isColor('red')
            ? this.renderCell('red')
            : this.isColor('yellow')
            ? this.renderCell('yellow')
            : this.isColor('green')
            ? this.renderCell('green')
            : this.isColor('blue')
            ? this.renderCell('blue')
            : this.isColor('magenta')
            ? this.renderCell('magenta')
            : null}
        </div>
        {board && cell.hasDot ? (
          <div
            className="tm-dot-area"
            style={{ width, height: width, transform }}
            onTouchStart={() => this.handleTouch(false)}
            onMouseDown={() => this.handleMouseDown(false)}>
            <div style={{ border: '1px solid black', borderRadius: '50%' }}>
              <div className="tm-dot" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Cell;
